import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StatusTabs from './StatusTabs';
import GenericTable from './GenericTable';
import Pagination from './Pagination';

const factureStatuts = [
  {
    value: 'Payée',
    label: 'Payée',
    style: {
      backgroundColor: 'green',
      color: 'white',
      padding: '2px 6px',
      borderRadius: '4px',
    },
  },
  {
    value: 'Non payée',
    label: 'Non payée',
    style: {
      backgroundColor: 'red',
      color: 'white',
      padding: '2px 6px',
      borderRadius: '4px',
    },
  },
];

const FactureList = ({ fetchUrl, headerComponent: Header, footerComponent: Footer, columns, userType }) => {
  const [factures, setFactures] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState(null);
  const [grouped, setGrouped] = useState({});
  const [page, setPage] = useState(1);
  const [displayMode, setDisplayMode] = useState('table');
  const [visibleCount, setVisibleCount] = useState(8);
  const itemsPerPage = 8;
  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchFactures = async () => {
      try {
        const res = await fetch(fetchUrl, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await res.json();
        setFactures(data);

        setGrouped({
          Payée: data.filter((f) => f.statutPaiement === 'Payée'),
          'Non payée': data.filter((f) => f.statutPaiement === 'Non payée'),
        });
      } catch (err) {
        console.error('Erreur chargement factures:', err);
      }
    };

    fetchFactures();
  }, [fetchUrl, authToken]);

  useEffect(() => {
    setPage(1);
    setVisibleCount(8);
  }, [filteredStatus]);

  const filteredFactures =
    filteredStatus === null
      ? factures
      : factures.filter((f) =>
          filteredStatus === 'Payée'
            ? f.statutPaiement === 'Payée'
            : f.statutPaiement === 'Non payée'
        );

        const formatFactures = (list) =>
            list.map((f) => {
              const statut = factureStatuts.find((s) => s.label === f.statutPaiement);
          
              return {
                numeroFacture: f.numeroFacture,
                mission: f.mission?.nomMission || 'N/A',
                recruteur: f.recruteur
                  ? `${f.recruteur.firstName} ${f.recruteur.lastName}`
                  : 'N/A',
                montant: `${f.montant} €`,
                statut: (
                  <span style={statut?.style}>
                    {statut?.label || 'Statut inconnu'}
                  </span>
                ),
                dateCreation: new Date(f.dateCreation).toLocaleDateString('fr-FR'),
                _id: f._id,
              };
            });
          

  const formattedData = formatFactures(filteredFactures);
  const paginated = formattedData.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  const cardData = formattedData.slice(0, visibleCount);

  const renderActions = (row) => (
    <button
      onClick={() =>
        navigate(`/facture/${row._id}`, {
          state: { facture: factures.find(f => f._id === row._id) },
        })
      }
      className="btn-detail"
    >
      Voir détails
    </button>
  );

  return (
    <div className={`${userType}-page`}>
      <main className="pageContainer">
        <h2 className="pageTitle">Mes factures</h2>

        <StatusTabs
          statuses={grouped}
          activeStatus={filteredStatus}
          onStatusChange={setFilteredStatus}
          statusStylesSource={factureStatuts}
        />

        <GenericTable
          displayMode={displayMode}
          setDisplayMode={setDisplayMode}
          columns={columns}
          data={displayMode === 'card' ? cardData : paginated}
          renderActions={renderActions}
          totalItems={displayMode === 'card' ? cardData.length : filteredFactures.length}
          showCheckboxes={false}
        />

        {displayMode === 'table' && (
          <Pagination
            page={page}
            setPage={setPage}
            totalItems={filteredFactures.length}
            itemsPerPage={itemsPerPage}
          />
        )}

        {displayMode === 'card' && visibleCount < filteredFactures.length && (
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <button onClick={() => setVisibleCount((v) => v + 8)} className="btn-charger-plus">
              Charger plus
            </button>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default FactureList;
